<template>
  <span>
    <div class="row">
      <div class="col-md-4">
        <label class="col-form-label">Name</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.name"
            class="form-control"
            autocomplete="off"
            placeholder="Name"
          />
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">City</label>
        <div class="col-sm-12">
          <my-select
            disableFormControl="true"
            :selection.sync="form.city_id"
            :suggestions="cities"
            placeholder="Select city"
          ></my-select>
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Country</label>
        <div class="col-sm-12">
          <my-select
            disableFormControl="true"
            :selection.sync="form.country_id"
            :suggestions="countries"
            placeholder="Select country"
          ></my-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <label class="col-form-label">Phone</label>
        <div class="col-sm-12">
          <input
            type="number"
            v-model="form.phone"
            class="form-control"
            placeholder="Phone"
          />
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Fax Number</label>
        <div class="col-sm-12">
          <input
            type="number"
            v-model="form.fax"
            class="form-control"
            placeholder="Fax Number"
          />
        </div>
      </div>
      <div class="col-md-4">
        <label class="col-form-label">Address</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.address"
            class="form-control"
            placeholder="Address"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label class="col-form-label">Brief Info</label>
        <div class="col-sm-12">
          <input
            type="text"
            v-model="form.info"
            class="form-control"
            placeholder="Brief info"
          />
        </div>
      </div>

      <div class="col-md-6">
        <label class="col-form-label">Logo</label>
        <div class="col-sm-12">
          <input
            type="file"
            id="file"
            name="file"
            ref="file"
            accept="application/ms-excel"
          />
        </div>
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "OrganizationFormWidget",
  props: ["form"],
  data() {
    return {
      countries: [],
      cities: [],
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("organizations/masters");
      masters = masters.data;
      masters.countries.forEach((country) => {
        this.countries.push({
          id: country.id,
          name: country.name,
        });
      });
      masters.cities.forEach((city) => {
        this.cities.push({
          id: city.id,
          name: city.name,
        });
      });
    },
  },
};
</script>
